<template>
  <div class="components-page-manage scrollbar-wrapper">
    <p class="page-title text-center">页面选择</p>
    <el-select
      class="page-select"
      v-model="currentPageUUID"
      placeholder="请选择"
    >
      <el-option
        v-for="(i, k) in projectData.pages"
        :key="k"
        :label="`${k + 1}、${i.name?i.name:`第${k + 1}页`}`"
        :value="i.uuid"
      >
      </el-option>
    </el-select>
    <p class="text-center">元件管理</p>
    <el-scrollbar style="height: 50%" class="components-main-conten">
      <el-tree
        :data="list"
        :props="{ children: 'list', label: 'name' }"
        default-expand-all
        @node-click="handleNodeClick"
        :expand-on-click-node="false"
        draggable
        :allow-drop="allowDropHandler"
        :allow-drag="allowDragHandler"
        @node-drop="dropHandler"
      >
        <span class="node-container" slot-scope="{ node, data }">
          <span
            class="node-default"
            :class="{
              nodeActive:
                activeElementUUIDMore.includes(data.uuid) ||
                activeElementUUID == data.uuid ||
                activeElementGroupUUID == data.uuid || 
                (activeDynamicPanelUUID == data.uuid && data.uuid == activeElementUUID) || 
                (activeDynamicPanelStateUUID == data.uuid && activeElement && activeElement.dynamicPanelStateUUID != data.uuid),
            }"
            >{{ node.label
            }}{{ data.isGroup || !data.zIndex ? "" : `-层级:${data.zIndex}` }}</span
          >
          <div class="page-item-btn-wrapper pull-right width20" v-if="!data.isState">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                <i class="el-icon-more-outline"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(m, n) in data.isGroup ? groupOptions : menuOptions"
                  :key="n"
                >
                  <div
                    class="btn-item"
                    @click="
                      handleElementCommand({
                        uuid: data.uuid,
                        command: m.value,
                      })
                    "
                  >
                    <i :class="m.icon"></i> {{ m.title }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </span>
      </el-tree>
    </el-scrollbar>
    <slot></slot>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      groupOptions: [
        {
          title: "复制",
          icon: "iconfont iconfuzhi",
          value: "copyElementGroups",
        },
        {
          title: "取消组合元件",
          icon: "iconfont iconshanchu",
          value: "deleteElementGroups",
        },
        {
          title: "图层上移",
          icon: "iconfont iconziyuan1",
          value: "layerUp",
        },
        {
          title: "图层下移",
          icon: "iconfont iconxiayiyiceng",
          value: "layerDown",
        },
        {
          title: "图层置顶",
          icon: "iconfont iconcontrol-top",
          value: "layerTop",
        },
        {
          title: "图层置底",
          icon: "iconfont iconcontrol-bottom",
          value: "layerBottom",
        },
      ],
      menuOptions: [
        {
          title: "复制",
          icon: "iconfont iconfuzhi",
          value: "copy",
        },
        {
          title: "删除",
          icon: "iconfont iconshanchu",
          value: "delete",
        },
        {
          title: "图层上移",
          icon: "iconfont iconziyuan1",
          value: "layerUp",
        },
        {
          title: "图层下移",
          icon: "iconfont iconxiayiyiceng",
          value: "layerDown",
        },
        {
          title: "图层置顶",
          icon: "iconfont iconcontrol-top",
          value: "layerTop",
        },
        {
          title: "图层置底",
          icon: "iconfont iconcontrol-bottom",
          value: "layerBottom",
        },
      ],
      currentPageUUID: "",
      list: [],
    };
  },
  computed: {
    ...mapState({
      projectData: (state) => state.editor.projectData,
      activePageUUID: (state) => state.editor.activePageUUID,
      activeElementUUID: (state) => state.editor.activeElementUUID,
      activeElementUUIDMore: (state) => state.editor.activeElementUUIDMore,
      activeElementGroupUUID: (state) => state.editor.activeElementGroupUUID,
      activeDynamicPanelUUID: (state) => state.editor.activeDynamicPanelUUID,
      activeDynamicPanelStateUUID: (state) => state.editor.activeDynamicPanelStateUUID,
    }),
    ...mapGetters([
      "currentPageIndex",
      "activeElementIndex",
      "activeElement",
      "activeElementGroup",
      "activePage",
      "elementManage",
    ]),
  },
  watch: {
    currentPageUUID(val) {
      this.$store.dispatch("setActiveElementUUID", "");
      this.$store.dispatch("setActiveElementUUIDMore", "");
      this.$store.dispatch("setActiveElementGroupUUID", "");
      this.$store.dispatch("setActivePageUUID", val);
      this.list = this.elementManage;
    },
    "activeElement.elNameShow": function () {
      this.list = this.elementManage;
    },
    activeElementGroupUUID() {
      this.list = this.elementManage;
    },
    activePageUUID() {
      this.list = this.elementManage;
      this.currentPageUUID = this.activePageUUID;
    },
    // elementManage(val){
    //   console.log('==========================================')
    //   console.log(val, 'elementManage')
    //   console.log(this.activePage.elements, 'activePage-elements')
    //   console.log(this.activePage.elementGroups, 'activePage-elementGroups')
    //   console.log('==========================================')
    //   this.list = val;
    // },
  },
  mounted() {
    setTimeout(() => {
      this.currentPageUUID = this.activePageUUID;
      this.list = this.elementManage;
      console.log(this.activePage, "!!!");
      console.log(this.elementManage, "elementManage");
    }, 400);
  },
  methods: {
    allowDragHandler(draggingNode){
      return !draggingNode.data.isState
    },
    allowDropHandler(draggingNode, dropNode, type) {
      // 动态面板之间不能嵌套
      return !(
        type == "inner" ||
        (draggingNode.data.isGroup && (dropNode.level == 2 || dropNode.level == 4)) || 
        dropNode.data.isDynamicPanel == 1 || dropNode.data.isState == 1
      );
    },
    listRefresh() {
      this.list = this.elementManage;
    },
    dropHandler(draggingNode, dropNode, dropType) {
      // draggingNode 被拖拽的节点
      // dropNode 结束拖拽时最后进入的节点
      // dropType 被拖拽节点的放置位置（before、after、inner）
      const dragGroupSelfIndex = this.activePage.elementGroups.findIndex((m) => m.uuid == draggingNode.data.uuid);
      const dragGroupIndex = this.activePage.elementGroups.findIndex((i) =>
        i.list.find((m) => m == draggingNode.data.uuid)
      );
      if (dragGroupIndex > -1) {
        // 组合内元件，脱离原有组合
        this.activePage.elementGroups[dragGroupIndex].list.splice(
          this.activePage.elementGroups[dragGroupIndex].list.findIndex(
            (i) => i == draggingNode.data.uuid
          ),
          1
        );
      }
      const dragIndex = this.activePage.elements.findIndex((m) => m.uuid == draggingNode.data.uuid);
      // 动态面板内的元件
      if(draggingNode.data.dynamicPanelUUID){
        if(dragIndex > -1){
          // 动态面板内元件，脱离原有动态面板
          this.activePage.elements[dragIndex].dynamicPanelUUID = '';
          this.activePage.elements[dragIndex].dynamicPanelStateUUID = '';
        }
        if(dragGroupSelfIndex > -1){
          // 动态面板内组合，组合本身+组合内所有元件，脱离原有动态面板
          this.activePage.elementGroups[dragGroupSelfIndex].dynamicPanelUUID = '';
          this.activePage.elementGroups[dragGroupSelfIndex].dynamicPanelStateUUID = '';
          this.activePage.elementGroups[dragGroupSelfIndex].list.map((z)=>{
            const elementIndex = this.activePage.elements.findIndex((m) => m.uuid == z);
            this.activePage.elements[elementIndex].dynamicPanelUUID = '';
            this.activePage.elements[elementIndex].dynamicPanelStateUUID =  '';
          })
        }
      }
      let dropGroupIndex = -1;
      // 判断最后进入的节点的层级
      if (dropNode.level == 2 || dropNode.level == 4) {
        // 组合内 => 将被拖拽的元件并入组合中
        dropGroupIndex = this.activePage.elementGroups.findIndex((i) =>
          i.list.find((m) => m == dropNode.data.uuid)
        );
        if (dropGroupIndex > -1) {
          const dropInnerIndex = this.activePage.elementGroups[
            dropGroupIndex
          ].list.findIndex((m) => m == dropNode.data.uuid);
          let dropIndexNext = dropInnerIndex;
          if (dropType == "before") {
            dropIndexNext = dropInnerIndex < 1 ? 0 : dropInnerIndex - 1;
          } else if (dropType == "after") {
            dropIndexNext =
              dropInnerIndex <
              this.activePage.elementGroups[dropGroupIndex].list.length - 1
                ? dropInnerIndex + 1
                : this.activePage.elementGroups[dropGroupIndex].list.length - 1;
          }
          this.activePage.elementGroups[dropGroupIndex].list.splice(
            dropIndexNext,
            0,
            draggingNode.data.uuid
          );
        }
      }
      if(dropNode.data.dynamicPanelUUID){
        // 动态面板标记
        if(dragIndex > -1 && !draggingNode.data.isGroup){
          this.activePage.elements[dragIndex].dynamicPanelUUID =  dropNode.data.dynamicPanelUUID;
          this.activePage.elements[dragIndex].dynamicPanelStateUUID = dropNode.data.dynamicPanelStateUUID;
        }
        if (dragGroupSelfIndex > -1 && draggingNode.data.isGroup) {
          this.activePage.elementGroups[dragGroupSelfIndex].dynamicPanelUUID =  dropNode.data.dynamicPanelUUID;
          this.activePage.elementGroups[dragGroupSelfIndex].dynamicPanelStateUUID = dropNode.data.dynamicPanelStateUUID;
          this.activePage.elementGroups[dragGroupSelfIndex].list.map((z)=>{
            const elementIndex = this.activePage.elements.findIndex((m) => m.uuid == z);
            this.activePage.elements[elementIndex].dynamicPanelUUID =  dropNode.data.dynamicPanelUUID;
            this.activePage.elements[elementIndex].dynamicPanelStateUUID =  dropNode.data.dynamicPanelStateUUID;
          })
        }
      }
      console.log(this.list, 'change')
      // 重置所有层级，刷新
      this.$nextTick(() => {
        this.$store.dispatch("resetAllElementZIndex", { array: this.list });
        this.listRefresh();
      });
    },
    handleNodeClick(data) {
      if (data.isGroup) {
        data.list.map((i) => {
          this.$store.dispatch("setActiveElementUUID", i.uuid);
          this.$store.dispatch("setActiveElementUUIDMore", i.uuid);
        });
        this.$store.dispatch("setActiveElementGroupUUID", data.uuid);
      } else if(data.isState){
        const dynamicPanel = this.activePage.elements.filter((i)=>i.isDynamicPanel).find((i)=>i.states.find((m)=>m.uuid == data.uuid))
        if(dynamicPanel){
          this.$store.dispatch("setActiveElementGroupUUID", "");
          this.$store.dispatch("setActiveElementUUIDMore", "");
          this.$store.dispatch("setActiveElementUUID", dynamicPanel.uuid);
          this.$store.dispatch("setActiveDynamicPanelUUID", dynamicPanel.uuid);
          this.$store.dispatch("setActiveDynamicPanelStateUUID", data.uuid);
        }
      } else {
        this.$store.dispatch("setActiveElementGroupUUID", "");
        this.$store.dispatch("setActiveElementUUIDMore", "");
        this.$store.dispatch("setActiveElementUUID", data.uuid);
      }
    },
    /**
     * 切换选中页面
     * @param item
     */
    changeActiveElement(item) {
      this.$store.dispatch("setActiveElementUUID", item.uuid);
    },
    /**
     * 对元素进行操作命令
     */
    handleElementCommand({ uuid, command }) {
      this.$store.dispatch("elementCommand", { uuid, command });
      // this.$store.dispatch("resetElementZIndex", { uuid, type });
      this.$nextTick(() => {
        this.listRefresh();
      });
    },
  },
};
</script>

<style lang="scss">
.el-tree{
  background: unset;
  color: #fff;
}
.el-tree-node__content:hover{
  background: unset;
}
.el-input--suffix .el-input__inner{
  background: #1f2353;
  color: #fff;
}
</style>
<style lang="scss" scoped>
.components-page-manage {
  height: 100%;
  padding-top: 60px;
  padding-bottom: 60px;
  position: relative;
}
.node-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.node-default {
  font-size: 14px;
  flex: 1;
}
.nodeActive {
  color: #416bf4;
}
.page-title {
  position: absolute;
  top: 16px;
  left: 0;
  width: 100%;
  color: #fff;
}
.page-select {
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-bottom: 20px;
}
.page-item {
  min-height: 36px;
  line-height: 36px;
  width: 100%;
  cursor: pointer;
  transition: all 0.28s;
  border-bottom: 1px solid #e6ebed;
  background: white;
  color: #666666;
  padding: 0 10px;
  display: flex;
  & > .pull-right {
    width: 20px;
    &.custom-loading-btn {
      width: 84px;
    }
  }
  & > .inline-block {
    flex: 1;
    font-size: 12px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  span {
    flex-shrink: 0;
  }
  p {
    flex: 1;
    display: inline-block;
    line-height: 16px;
  }
  &:hover {
    background-color: #eee;
    .page-item-btn-wrapper {
      display: block;
      opacity: 1;
    }
  }
  &.active {
    background-color: #eee;
    color: #111;
    .page-item-index {
      background: $primary;
      color: white;
    }
  }
  .page-item-index {
    display: inline-block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 12px;
    background-color: #ccc;
    color: #fff;
    margin-right: 8px;
  }
  .page-item-btn-wrapper {
    .btn-item {
      display: inline-block;
      padding: 4px 4px;
      font-size: 18px;
      transition: all 0.28s;
      &:hover {
        color: $primary;
        transform: scale(1.05);
      }
    }
  }
}
.bottom-btn-wrapper {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 60px;
  text-align: center;
  width: 100%;
  padding-top: 12px;
}
</style>
